<template>
  <div>
    <div class="columns is-desktop">
      <div class="column is-three-fifths-desktop ratesAtWorkIntroduction">
        <p class="subtitle">
          We are committed to creating a liveable city that remains appealing to residents, businesses
          and visitors alike. To this end, your rates contribution enables investment in new and extended services,
          programs and facilities, and continues with the activation of the city.
        </p>
        <p class="subtitle">
          We want our city to be a vibrant inclusive place, well positioned to meet the opportunities
          and challenges of a growing and changing city for decades to come. In line with the adopted Budget, we have
          determined how every dollar of your rates will make it possible for us to undertake a huge number of
          activities that will help keep our community vibrant, safe and healthy.
        </p>

        <small v-if="selectedYearMaps=='2018/2019'">
          <a
            target="_blank"
            :href="url_desktop_prefix + '?STATUS=CLOSED&FINANCIAL_YEAR=' + selectedYearMaps"
            class="is-hidden-mobile"
          >
            <span class="icon">
              <i class="fa fa-map-marker-alt"></i>
            </span>
            View Closed Projects from {{ selectedYearMaps }} on Map
          </a>
          <a
            target="_blank"
            :href="url_mobile_prefix + '?STATUS=CLOSED&FINANCIAL_YEAR=' + selectedYearMaps"
            class="is-hidden-desktop is-hidden-tablet"
          >
            <span class="icon">
              <i class="fa fa-map-marker-alt"></i>
            </span>
            View Closed Projects from {{ selectedYearMaps }} on Map
          </a>
        </small>

        <small v-if="selectedYearMaps=='2019/2020' || selectedYearMaps=='2020/2021'">
          <a
            target="_blank"
            :href="url_desktop_prefix + '?STATUS=OPEN&FINANCIAL_YEAR=' + selectedYearMaps"
            class="is-hidden-mobile"
          >
            <span class="icon">
              <i class="fa fa-map-marker-alt"></i>
            </span>
            View Open Projects for {{ selectedYearMaps }} on Map
          </a>
          <a
            target="_blank"
            :href="url_mobile_prefix + '?STATUS=OPEN&FINANCIAL_YEAR=' + selectedYearMaps"
            class="is-hidden-desktop is-hidden-tablet"
          >
            <span class="icon">
              <i class="fa fa-map-marker-alt"></i>
            </span>
            View Open Projects for {{ selectedYearMaps }} on Map
          </a>
        </small>
      </div>

      <div class="column is-two-fifths-desktop ratesAtWorkCalculator">
        <div class="notification is-warning">
          <h3 class="title is-3" style="margin-bottom: .5rem;">See your rates at work</h3>

          <div class="tabs is-toggle is-fullwidth">
            <ul>
              <li
                v-for="period in filteredPeriods"
                :key="period.id"
                :class="{'is-active' : period.selected}"
                @click="togglePeriods(period.year)"
              >
                <a style="text-decoration: none;" :class="[(period.selected ? '' : 'is-white' )]">
                  <div style="text-align: center; line-height: 1em;">
                    <template v-if="period.type=='current'">
                      <small class="capitalise">
                        <strong>{{ period.type }}</strong>
                      </small>
                    </template>
                    <template v-else>
                      <small class="capitalise">{{ period.type }}</small>
                    </template>
                    <br />
                    <small>Budget</small>
                    <br />
                    <p style="line-height: 1.6em;">{{ period.year }}</p>
                  </div>
                </a>
              </li>
            </ul>
          </div>

          <div class="column">
            <div class="field">
              <div class="control">
                <label class="radio">
                  <input
                    type="radio"
                    name="calctype"
                    v-model="calctype"
                    checked
                    id="dollar"
                    value="Dollar"
                  />
                  By the dollar $1.00
                </label>
              </div>
            </div>
          </div>

          <div class="column">
            <div class="field">
              <div class="control">
                <label class="radio">
                  <input
                    type="radio"
                    name="calctype"
                    v-model="calctype"
                    checked
                    id="rates"
                    value="Rates"
                  />
                  <strong>By your rate amount</strong>
                </label>
              </div>
            </div>
          </div>

          <div class="field" v-if="calctype=='Rates'">
            <p class="control">
              <small>(Enter the amount shown on your rate notice)</small>
              <vue-numeric
                currency="$"
                class="input is-large"
                v-bind:precision="2"
                autofocus
                separator=","
                v-model="rates"
                :empty-value="1"
                :disabled="calctype!=='Rates'"
              ></vue-numeric>
            </p>
          </div>

          <div class="column">
            <div class="field">
              <div class="control">
                <label class="radio">
                  <input
                    type="radio"
                    name="calctype"
                    v-model="calctype"
                    checked
                    id="budget"
                    value="Budget"
                  />
                  By
                  <template
                    v-if="budgetType!='current' && budgetType!='proposed'"
                  >
                    {{ selectedYear }} Budget
                    ${{ budget.toLocaleString('en') }}
                  </template>
                  <template v-if="budgetType=='current'">
                    Current Budget
                    ${{ budget.toLocaleString('en') }}
                    *
                    <br />
                    <div style="padding: 0 1em;">
                      <small>(Adopted operating and capital budget for {{ selectedYear }})</small>
                    </div>
                  </template>
                  <template v-if="budgetType=='proposed'">
                    Proposed Budget
                    ${{ budget.toLocaleString('en') }}
                    <template v-if="showRoundingNote">*</template>
                    <br />
                    <div style="padding: 0 1em;">
                      <small>(Proposed operating and capital budget for {{ selectedYear }})</small>
                    </div>
                  </template>
                </label>
              </div>
            </div>
            <small style="color: #9a811d;" v-if="showRoundingNote">* rounded to nearest 1,000</small>
          </div>
        </div>
      </div>
    </div>

    <div v-for="item in items" :key="item.id">
      <div class="level">
        <div class="level-item has-text-centered ratesAtWorkImage">
          <div>
            <figure class="image" style="width: 196px; height: 196px;">
              <img :src="'/images/CityPlan/'+item.image" style="XXborder-radius: 98px;" />
            </figure>
          </div>
        </div>
        <div class="level-item has-text-centered ratesAtWorkContent">
          <div>
            <p class="title" style="margin-top: 10px;">{{ item.title }}</p>
            <p style="margin-bottom: 10px;">{{ item.description }}</p>

            <div v-if="item.goals" style="text-align: center; margin-bottom: 1em;">
              <br />
              <figure
                v-for="goal in item.goals"
                :key="goal.id"
                class="image themes"
                style="display: block"
              >
                <h3>{{ goal.title }}</h3>
                <small>{{ themes[goal.title].tagline }}</small>
                <!-- <img :src="goal.image_url" :title="goal.title" style="border-radius: 32px;" /> -->
              </figure>
            </div>

            <template v-if="selectedYear != '2020/21XXXX'">
              <div v-if="item.stories || item.videos">
                <small>
                  <strong style="display:none;">Project examples in {{ selectedYear }}</strong>
                  <strong>Project examples</strong>
                </small>
              </div>

              <div v-if="item.stories">
                <div v-for="story in item.stories" :key="story.id">
                  <!-- v-if="story.story && (story.storyBudgetYear == '0' || story.storyBudgetYear == selectedYear)" -->
                  <div
                    style="font-size: .8em;"
                  >
                    <a @click="story.storyModal = true">
                      <span class="icon">
                        <i class="fa fa-comment"></i>
                      </span>
                      {{ story.storyTitle }}
                    </a>
                  </div>

                  <div
                    v-if="story.story"
                    class="modal"
                    v-bind:class="{'is-active' : story.storyModal}"
                  >
                    <div class="modal-background"></div>
                    <div class="modal-content">
                      <div class="notification is-primary has-text-left">
                        <button class="delete" @click="story.storyModal = false"></button>
                        <h3 class="title">{{ story.storyTitle }}</h3>
                        <div v-html="story.story" class></div>
                        <!-- change selectedYearMaps year in the future -->

                        <div v-for="map in story.maps" :key="map.id">
                          <template
                            v-if="map.mapBudgetYear == '0' || map.mapBudgetYear == selectedYear"
                          >
                            <span class="icon">
                              <i class="fa fa-map-marker-alt"></i>
                            </span>
                            <a
                              target="_blank"
                              class="is-hidden-mobile"
                              :href="url_desktop_prefix+story.map+selectedYearMaps"
                            >{{ (map.title) ? map.title : "View on Map" }}</a>
                            <a
                              target="_blank"
                              class="is-hidden-desktop is-hidden-tablet"
                              :href="url_mobile_prefix+story.map+selectedYearMaps"
                            >{{ (map.title) ? map.title : "View on Map" }}</a>
                          </template>
                        </div>
                      </div>
                    </div>
                    <button
                      class="modal-close is-large"
                      aria-label="close"
                      @click="story.storyModal = false"
                    ></button>
                  </div>
                </div>
              </div>

              <div v-if="item.videos">
                <div v-for="video in item.videos" :key="video.id">
                  <!-- <a @click="item.videoModal = true"><span class="icon"><i class="fa fa-youtube-play"></i></span>{{ item.videoTitle }}</a> -->
                  <a :href="video.video" target="_blank" style="font-size: .8em;">
                    <span class="icon">
                      <i class="fab fa-youtube"></i>
                    </span>
                    {{ video.videoTitle }}
                  </a>
                </div>
              </div>
            </template>
            <!-- 
						<div v-if="item.video" class="modal" v-bind:class="{'is-active' : item.videoModal}">
						  <div class="modal-background"></div>
						  <div class="modal-content">
						    <div class="notification is-primary has-text-left"  style="background: transparent;">
							  <iframe width="560" height="315" :src="item.video" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
							</div>

						  </div>
						  <button class="modal-close is-large" aria-label="close" @click="item.videoModal = false"></button>
						</div>
            -->
          </div>
        </div>
        <div class="level-item has-text-centered ratesAtWorkList">
          <div>
            <p class="heading">Further reading...</p>
            <ul>
              <sectionlinks :links="item.links"></sectionlinks>
            </ul>
            <!-- change selectedYearMaps year in the future -->
            <div v-if="item.maps && selectedYearMaps == '2018/2019'">
              <hr style="margin: .5em 0;" />
              <p class="heading" style="margin-top: 1em;">Projects</p>
              <div v-for="map in item.maps" :key="map.id">
                <small>
                  <a target="_blank" :href="map.url_desktop" class="is-hidden-mobile">
                    <span class="icon">
                      <i class="fa fa-map-marker-alt"></i>
                    </span>
                    {{ map.title }}
                  </a>
                  <a
                    target="_blank"
                    :href="map.url_mobile"
                    class="is-hidden-desktop is-hidden-tablet"
                  >
                    <span class="icon">
                      <i class="fa fa-map-marker-alt"></i>
                    </span>
                    {{ map.title }}
                  </a>
                </small>
              </div>
            </div>
          </div>
        </div>

        <div class="level-item has-text-centered ratesAtWorkAmount">
          <div>
            <p class="title" :class="budgetType">
              <template>{{ calculation(item[selectedYearMaps]['budget']) }}</template>
            </p>
          </div>
        </div>
      </div>
      <hr />
    </div>

    <div>
      <div class="level">
        <div class="level-item">
          <div class="ratesAtWorkTotal">
            <label class="title" v-if="calctype=='Dollar'">Total {{ toCurrency(dollar) }}</label>
            <label class="title" v-if="calctype=='Rates'">Total {{ toCurrency(rates) }}</label>
            <label class="title" v-if="calctype=='Budget'">Total {{ toCurrency(budget) }}</label>

            <br />
            <small
              v-if="dollar==1.01 && calctype=='Dollar'"
            >(total amount equals $1.01 due to rounding)</small>
            <small
              v-if="dollar==1.02 && calctype=='Dollar'"
            >(total amount equals $1.02 due to rounding)</small>

            <small v-if="calctype=='Budget'">* with rounding</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var Vue = require("vue");
import VueNumeric from "vue-numeric";

import sectionlinks from "./SectionLinks";

export default {
  components: {
    sectionlinks,
    VueNumeric,
  },
  mounted() {
    this.updateValues();
  },
  computed: {
    filteredPeriods() {
      return this.periods.filter((period) => {
        return period.active == true;
      });
    },
  },
  data() {
    return {
      periods: [
        {
          year: "2020/21",
          yearMaps: "2020/2021",
          active: true,
          selected: false,
          type: "previous", // previous, current, proposed
          budget: 185947400,
          dollar: 1.0,
          showRoundingNote: true,
        },
        {
          year: "2021/22",
          yearMaps: "2021/2022",
          active: true,
          selected: true,
          type: "current", // previous, current, proposed
          budget: 190854700,
          dollar: 1.0,
          showRoundingNote: false,
        },
      ],
      
      budgetType: "current",
      selectedYear: "2021/22",
      selectedYearMaps: "2021/2022",
      url_desktop_prefix:
        "http://portenf.maps.arcgis.com/apps/opsdashboard/index.html#/dcbabf3c24384572ba2b93ae55f79146",
      url_mobile_prefix:
        "http://portenf.maps.arcgis.com/apps/opsdashboard/index.html#/932bfad864e1485a9de0ac7235c35e25",
      dollar: 1.0,
      rates: 0,
      budget: 0,
      totalAmount: 0,
      displayProposed: true,
      enableProposedBudgetView: true,
      showRoundingNote: false,
      calctype: "Dollar",
      themes: {
        Economy: {
          title: "Economy",
          tagline: "Thriving economy and a business-friendly City",
        },
        Community: {
          title: "Community",
          tagline:
            "Safe, vibrant, inclusive and welcoming city for our residents, businesses and visitors alike",
        },
        Environment: {
          title: "Environment and Heritage",
          tagline:
            "Low carbon, water sensitive and climate resilient City and our built heritage is protected, embraced and celebrated",
        },
        Placemaking: {
          title: "Placemaking",
          tagline:
            "Unique and distinctive collection of active places, created and cared for through strong partnerships",
        },
        Leadership: {
          title: "Leadership",
          tagline:
            "Collaborative, innovative, and high performing leader within local government",
        },
      },
      items: [
        {
          title: "Maintaining spaces to play and relax",
          description:
            "To keep you active, healthy and connected we manage our many playgrounds, parks, gardens, picnic spaces, golf courses and specific sporting grounds and facilities.",
          image: "rates-recreation.jpg",
          // budget: {
          //   "2018/2019": 0.2457,
          //   "2019/2020": 0.1832,
          //   "2020/2021": 0.888888888888
          // },
          "2018/2019": {
            budget: 0.2457,
          },
          "2019/2020": {
            budget: 0.1832,
          },
          "2020/2021": {
            budget: 0.203104,
          },
          "2021/2022": {
            budget: 0.18,
          },

          links: [
            {
              title: "Playgrounds, Parks and Gardens",
              url: "406460",
            },
            {
              title: "Picnic Spaces",
              url: "411009",
            },
            {
              title: "Dog Parks",
              url: "409247",
            },
            {
              title: "Golf Courses",
              url: "409267",
            },
            {
              title: "Sports Grounds and Facilities",
              url: "406460",
            },
          ],
          stories: [
            {
              storyBudgetYear: "2019/20",
              storyTitle: "Love the Lights",
              story:
                "<p>The Lights Community and Sports Centre is a world class indoor facility being built in Lightsview, with a focus on access and inclusion. The outside of the structure is almost complete and work on the inside is well underway. Inside there will be a café and commercial area, multiple accessible changing areas, meeting rooms and offices. The five courts will be used for basketball, netball, badminton or pretty much any other indoor sport you can imagine. Together the spaces can be used as a performance site or a community area for larger functions.<br/>Upstairs, overlooking the courts, are large, flexible community areas. Bright, spacious communal areas and hallways ensure plenty of room to move around. The two showcase courts can be used for everything from grassroots to international elite competition. They will include the first smart court technology installed in South Australia, with a system of 4k cameras that allows livestreaming, tracking technology and broadcast that can be used for instant play analysis, virtual whiteboards and highlight reels.<br/>The floor surface is superior quality hard maple which is the choice of 29 NBA teams and the Australian Institute of Sport. The Lights will be completed later in 2019 and will be a great resource for the local community.</p>",
              map: "?PROJECT_CODE=Y1819.P022&EXTENT=Y1819.P022&FINANCIAL_YEAR=",
              maps: [
                {
                  mapBudgetYear: "0",
                  title: null,
                  url:
                    "?PROJECT_CODE=Y1819.P022&EXTENT=Y1819.P022&FINANCIAL_YEAR=",
                },
                {
                  mapBudgetYear: "2019/20",
                  title: null,
                  url:
                    "?PROJECT_CODE=Y1819.P022&EXTENT=Y1819.P022&FINANCIAL_YEAR=",
                },
              ],
              storyModal: false,
            },
            {
              storyBudgetYear: "2018/19",
              storyTitle: "TK Shutter playspace looking terrific",
              story:
                "<p>Our outdoor field staff work hard to keep our open and recreational spaces looking great. Well cared for parks, streets and sports grounds contribute to our sense of place and community. TK Shutter Reserve, located on Fourth Avenue in Klemzig, is not far from the scenic River Torrens and is just one of the lovely plays spaces we have recently worked to improve.</p><p>This reserve was identified for upgrade when residents living around this large, under-utilised space expressed a desire for more recreational opportunities at their local park. Prior to the upgrade project, the dryland section of the reserve only featured a playground, shelter and poorly situated basketball half court. In consultation with residents, the Metro Stars Soccer Club and the Klemzig Kindergarten, an 800m long fitness track with seven fitness stations was installed to allow users to undertake a variety of exercise activities.</p><p>A new BBQ was installed within the existing shelter and the basketball half court was relocated. New nature play elements such as climbing logs, turfed mounds and a concrete tunnel were installed for use by children, and the park upgrades were completed with more turfed area and additional trees.  We aim to provide a mix of different types of open space for different members of our community and TK Shutter is now open for play!</p><p>In line with our City Plan 2030, the upgrade to TK Shutter Reserve is helping us to demonstrate our commitment to creating a distinctive City which supports community wellbeing by providing spaces that help people to feel healthy and connected.</p>",
              storyModal: false,
            },
          ],
          videos: [
            {
              videoTitle: "See inside the Lights",
              video:
                "https://www.youtube.com/watch?v=2OBND6NmHas&index=17&list=PL_Jwyun8ksFpdV0kKl_setkrV2ZMLF-L5",
              videoModal: false,
            },
          ],
          // maps: [
          //   {
          //     title: "View on Map",
          //     url_desktop: "?TYPE=Reserves&STATUS=OPEN&FINANCIAL_YEAR=",
          //     url_mobile: "?TYPE=Reserves&STATUS=OPEN&FINANCIAL_YEAR="
          //   }
          // ],
          goals: [
            {
              title: "Placemaking",
              image_url: "/images/CityPlan/cityplan-placemaking.png",
            },
          ],
        },

        {
          title: "Making our streets safer",
          description:
            "To enable you to access places, facilities and services across the city we oversee a vast network of roadways, bike trails and footpaths.",
          image: "rates-transport.jpg",
          // budget: {
          //   "2018/2019": 0.0,
          //   "2019/2020": 0.0,
          //   "2020/2021": 0.0
          // },
          "2018/2019": {
            budget: 0.2234,
          },
          "2019/2020": {
            budget: 0.241,
          },
          "2020/2021": {
            budget: 0.232417,
          },
          "2021/2022": {
            budget: 0.25,
          },          
          links: [
            {
              title: "Roads",
              url: "408795",
            },
            {
              title: "Footpaths",
              url: "412308",
            },
            {
              title: "Traffic Management",
              url: "412308",
            },
          ],
          stories: [
            {
              storyBudgetYear: "2019/20",
              storyTitle: "Safer Cycling in Ethelton",
              story:
                "<p>We are always considering ways to make it easier to get around by bike and to promote our City as a destination for cycling through the installation and maintenance of bike paths. Work has recently commenced on a shared use path for pedestrians and cyclists along Causeway Road between Semaphore Road and Bower Road.</p><p>It’s a busy part of our City, being close to Lefevre Peninsula Primary School, Portside Christian College and the Ethelton and Glanville Railway stations. Causeway Road provides a major transport link and carries around 13,000 vehicles daily.</p><p>The shared use path will make it safer and easier for people to enjoy a short stroll or ride to the attractions on Semaphore Road or to the Port Hike and Bike Loop Path.The work includes upgrade of the older shared use path near Bower Road and will connect to the existing section of path near Ethelton Station.</p><p>The shared path will improve public safety and amenity and reduce the likelihood of crashes by providing an alternative and safe route for both pedestrians and cyclists. In line with our City Plan 2030, the shared path helps us demonstrate our commitment to creating a distinctive and sustainable City in which places and services are easily accessible.</p>",
              storyModal: false,
            },
          ],
          videos: [
            {
              videoTitle: "A Day in the Life of - Minor Road Maintenance",
              video: "https://youtu.be/Dybpo_Rz5Ag",
              videoModal: false,
            },
          ],
          goals: [
            {
              title: "Placemaking",
              image_url: "/images/CityPlan/cityplan-placemaking.png",
            },
          ],
        },

        {
          title: "Harnessing our stormwater",
          description:
            "Water is a precious resource, so we strive to harvest, cleanse and reuse as much as possible for irrigating our parks and sportsgrounds, and also ensure we improve flood mitigation along our coast and waterways.",
          image: "rates-drainage-stormwater.jpg",
          // budget: {
          //   "2018/2019": 0.0,
          //   "2019/2020": 0.0,
          //   "2020/2021": 0.0
          // },
          "2018/2019": {
            budget: 0.11,
          },
          "2019/2020": {
            budget: 0.1195,
          },
          "2020/2021": {
            budget: 0.130145,
          },
          "2021/2022": {
            budget: 0.15,
          },          
          links: [
            {
              title: "Stormwater Management",
              url: "412397",
            },
            {
              title: "Pump Stations",
              url: "416242",
            },
          ],
          stories: [
            {
              storyBudgetYear: "2019/20",
              storyTitle: "Stormwater Upgrade in Kilburn/Blair Athol",
              story:
                "<p>Changes to the diverse population in the Kilburn Blair Athol area have been accompanied by changes to the landscape. Following completion of a major upgrade of Prospect Road, the State Government and Council have been working on redeveloping the area through street improvements, open space improvements and better linkages to public transport.<br/>The first stage of these works was the construction of new stormwater infrastructure in Marmion Avenue, from the Kilburn Open Channel Drain (between Tyne and Nelson Street) to Main North Road, followed by further works to Prospect Road and then across it. The stormwater upgrade on Marmion Avenue included the installation of a new concrete culvert on the northern side of the road and a new basin to further improve stormwater management in the area at Rushworth Reserve.  Our City Plan 2030 helps us plan and design a city that is modern, liveable and connected.</p>",
              storyModal: false,
            },
            {
              storyBudgetYear: "2019/20",
              storyTitle: "Planning for flooding events- together",
              story:
                "<p>Changes in urban design (including increased building densities and differences in the way our homes are designed) increase stormwater run-off and decrease the quality of stormwater entering our waterways. We are committed to reducing the impact that development is having on our environment by installing both hard (gross pollutant traps) and soft (water sensitive urban design) infrastructure throughout the Council area.</p><p>Some parts of our City are low-lying, and cannot discharge stormwater using gravity alone therefore; we have installed and maintain a number of large pumping stations and detention basins to help discharge stormwater to the Port River during rainfall events.</p><p>Stormwater Management Plans (SMP) allow us to understand and identify flood risk areas and prioritise works so expenditure can be planned in an informed and strategic way. Because of the potential impacts of flooding on our residents, we make sure we work with our communities on developing these strategies to reduce the risk of flooding.</p><p>The Lefevre Peninsula stormwater management plan, completed in 2017, was unique in that the community and stakeholder consultation played a very important part in the establishment of the plan and the outcomes that were included in the plan. Water quality modelling undertaken for the Lefevre Peninsula SMP is currently being used as a case study by Water Sensitive SA and the University College, London to guide further research into available methods for stormwater offset rate estimation.</p><p>The SMP was also recently shortlisted for a Local Government Award. Our work in the area of stormwater planning and management helps us demonstrate our City Plan 2030 commitment to creating a City which is resilient and which cares for its natural and built environment.</p>",
              storyModal: false,
            },
          ],
          goals: [
            {
              title: "Environment",
              image_url: "/images/CityPlan/cityplan-environment.png",
            },
          ],
        },

        {
          title: "Managing our resources",
          description:
            "To ensure we provide a positive experience and operate in the most efficient and cost effective manner possible, we continue to assess and improve our customer services, administration and depot operations.",
          image: "rates-business-administration.jpg",
          // budget: {
          //   "2018/2019": 0.0,
          //   "2019/2020": 0.0,
          //   "2020/2021": 0.0
          // },
          "2018/2019": {
            budget: 0.0825,
          },
          "2019/2020": {
            budget: 0.096,
          },
          "2020/2021": {
            budget: 0.102367,
          },
          "2021/2022": {
            budget: 0.08,
          },          
          links: [
            {
              title: "Administration",
              url: "408745",
            },
            {
              title: "Customer Service",
              url: "409432",
            },
            {
              title: "Depot Operations",
              url: "",
            },
          ],
          stories: [
            {
              storyBudgetYear: "2019/20",
              storyTitle: "Equipping our staff to assist you best",
              story:
                "<p>When you phone Port Adelaide Enfield Council, your first point of contact is likely to be with our Customer Relations Team in our busy Call Centre. In 2017 our team handled a whopping 14,1771 phone calls! Using their understanding of the local area, knowledge of services and with the assistance of computer mapping systems, Call Centre staff are able to deal with most calls directly. If not, they can pass you on to somebody who can help. </p><p>A major internal project has also improved our capacity to provide efficient on the road service delivery to the community. The Council’s 174 field staff now have access to ipads and new computer systems to replace paper-based management of customer service work order requests. This has removed costly overheads associated with data entry, missing forms, paper handling and error correction. And it’s already shown immense benefits; from the initial customer request and job scheduling, through to labour cost planning, plant management and reporting.</p><p>During 2017 we dealt with 47,482 requests for a huge variety of services, including linemarking, grass cutting, signage, potholes, abandoned vehicles, requests to film and pest removal.  We are continually working on improving ways in which customers can communicate with us and we are committed to handling compliments, requests and complaints consistently and fairly.  Whether in the Call Centre or out and about in the community, we value our people and the ways in which their work contributes to life in our City.   In line with our City Plan 2030, we are striving to be accountable for our work and to use opportunities provided by new technology to make improvements to our processes of customer service.</p>",
              storyModal: false,
            },
          ],
          goals: [
            {
              title: "Leadership",
              image_url: "/images/CityPlan/cityplan-leadership.png",
            },
          ],
        },

        {
          title: "Managing waste effectively",
          description:
            "Helping our planet is at the heart of our responsible and sustainable waste collection, recycling and composting programs and hard refuse disposal.",
          image: "rates-waste.jpg",
          // budget: {
          //   "2018/2019": 0.0,
          //   "2019/2020": 0.0,
          //   "2020/2021": 0.0
          // },
          "2018/2019": {
            budget: 0.0751,
          },
          "2019/2020": {
            budget: 0.0852,
          },
          "2020/2021": {
            budget: 0.078782,
          },
          "2021/2022": {
            budget: 0.07,
          },          
          links: [
            {
              title: "Rubbish Collection",
              url: "408869",
            },
            {
              title: "Recycling",
              url: "414715",
            },
            {
              title: "Hard Waste",
              url: "409424",
            },
          ],
          videos: [
            {
              videoTitle: "A Day in the Life of - Garbage Collection Truck",
              video: "https://youtu.be/rxcX7V7oc_s",
              videoModal: false,
            },
          ],
          goals: [
            {
              title: "Environment",
              image_url: "/images/CityPlan/cityplan-environment.png",
            },
          ],
        },

        {
          title: "Helping people be healthy and included",
          description:
            "The health and welfare of our community is paramount, so we have many services, community grants and programs for people from children and youths to the aged and disabled and our different cultures to connect.",
          image: "rates-community-cultural-programs.jpg",
          // budget: {
          //   "2018/2019": 0.0,
          //   "2019/2020": 0.0,
          //   "2020/2021": 0.0
          // },
          "2018/2019": {
            budget: 0.0577,
          },
          "2019/2020": {
            budget: 0.0626,
          },
          "2020/2021": {
            budget: 0.058656,
          },
          "2021/2022": {
            budget: 0.06,
          },          
          links: [
            {
              title: "Community Bus",
              url: "409000",
            },
            {
              title: "Community Centres",
              url: "411292",
            },
            {
              title: "Community Programs",
              url: "408749",
            },
            {
              title: "Kids and Youth Programs",
              url: "409295",
            },
            {
              title: "Services for the Aged and Disabled",
              url: "409452",
            },
            {
              title: "Volunteers",
              url: "409116",
            },
            {
              title: "Community Grants",
              url: "408964",
            },
            {
              title: "Immunisation",
              url: "414833",
            },
            {
              title: "Heritage",
              url: "414619",
            },
            {
              title: "Citizenship",
              url: "409416",
            },
          ],
          stories: [
            {
              storyBudgetYear: "2019/20",
              storyTitle: "Healthy and supported ageing",
              story:
                "<p>After giving up driving four years ago, Meta, a long term Windsor Gardens resident, felt at a loose end.  Some weeks she didn’t see anyone at all, until a neighbour mentioned Council’s van transport service. Meta now uses the shopping service for regular trips to Greenacres for shopping, and is also collected once a week to attend a social program, which she loves. Meta described the transport service, which is driven by volunteers, as having `opened new doors for her` and she says the drivers are simply `perfect`.<br/>At the social program at Kilburn Community Centre, participants play bingo and bocce or join in on chair based exercises.  They share a meal and important friendships are established and maintained. Meta says “Recently I couldn’t come for a few weeks, and I missed it. We talk about all sorts of things. You learn some things, you meet new people.”  Meta also attended information sessions during 2018 about aged care services. Facilitated by experts from various agencies, these presentations provided information about the many services provided by Council, community agencies and the State Government to support older people to remain at home for longer. Thankfully, Meta now feels confident that she will be able to stay at her home for many years yet, and the information sessions have equipped her with knowledge about the support that is available if she needs it.</p>",
              storyModal: false,
            },
            {
              storyBudgetYear: "2019/20",
              storyTitle: "Our City is a welcoming one",
              story:
                "<p>At Port Adelaide Enfield, we are a City that acknowledges and celebrates diversity.  The 2016 Census highlighted the high level of diversity in our City, with one third of the population born overseas, compared to approximately one quarter for the Adelaide population as a whole. Areas such as Kilburn/ Blair Athol and the Enfield/Clearview area in Council’s Enfield Ward have a particularly high number and proportion of people born overseas, including approximately a third of these residents arriving in Australia between 2011 and 2016.</p><p>The Welcoming Cities initiative supports local governments to commit to being more welcoming to new arrivals in their community. We are proud to be the first Council in South Australia to join this network, and make public our commitment to being a City that strives towards building social cohesion through the warm welcome of our newest residents.</p><p>We also recognise our Aboriginal and Torres Strait Islander people through our ATSI Awards, Walk of Awareness and the TARNANTHI at the Port event, and our support of the Reconciliation Walk and Tandanya`s Survival Day at Semaphore. In line with our City Plan 2030, we are striving to create a city where people love to be.  With everyone working well together, from our Councillors, to Council staff, to individuals and groups within the community, we become stronger, more united and connected.</p>",
              storyModal: false,
            },
          ],
          videos: [
            {
              videoTitle: "Home Support Services Can Help You",
              video: "https://youtu.be/TiEjsErEiMM",
              videoModal: false,
            },
          ],
          goals: [
            {
              title: "Community",
              image_url: "/images/CityPlan/cityplan-community.png",
            },
          ],
        },

        {
          title: "Creating opportunities to learn and grow",
          description:
            "Our libraries provide a hub of activities and lifelong learning for all ages, with physical and digital access to collections of information, resources, history and entertainment.",
          image: "rates-library.jpg",
          // budget: {
          //   "2018/2019": 0.0,
          //   "2019/2020": 0.0,
          //   "2020/2021": 0.0
          // },
          "2018/2019": {
            budget: 0.0618,
          },
          "2019/2020": {
            budget: 0.0523,
          },
          "2020/2021": {
            budget: 0.049535,
          },
          "2021/2022": {
            budget: 0.05,
          },          
          links: [
            {
              title: "Collections",
              url: "408682",
            },
            {
              title: "Kids and Youth Library Programs",
              url: "409420",
            },
            {
              title: "Local History",
              url: "409271",
            },
            {
              title: "Digital Literacy",
              url: "413444",
            },
          ],
          stories: [
            {
              storyBudgetYear: "2019/20",
              storyTitle: "Parks Library open for business",
              story:
                "<p>The modern Parks Library in Angle Park was opened to the public in late October 2018, with thousands of people turning up on the first day to view the new building and borrow from the extensive collection of books, magazines and toys.  The new Library incorporates the latest in technologies, from Smart Building Management Systems that feature automated control for lighting, ventilation, heating and cooling, security, and access to interactive display screens and wayfinding to help our community find the latest information on events and activities.  It features high definition projector screens in the community hall spaces, with linked AV capabilities. The ‘Makerspace’ offers a high tech creative space for everyone and includes an Audio Room and computers that feature the latest software for creating and editing sound and video.  The Children’s Area will has a dedicated Toy Collection and activity space with an interactive projector screen and 3D feature wall while the Meeting Rooms offer flexible activity spaces.  There is a packed schedule of programs and events for people of all ages from birth to seniors. This important community resource is fast becoming a hub for local people, where they can share, learn, meet and play.  Projects like the Parks help us deliver on our City Plan 2030 objectives around creating a city where people feel connected, respected and safe. The Parks Library is open seven days a week with extended hours on Monday and Wednesday until 7pm.</p>",
              storyModal: false,
            },
            {
              storyBudgetYear: "2019/20",
              storyTitle: "Connecting communities in more ways than one",
              story:
                "<p>Our four, soon to be five libraries, provide a place where people can connect with their local community, participate in programs and events, learn, create and access services and information that support community wellbeing and prosperity.  Each branch offers books, audio books, ebooks, magazines, music and movies, available in different languages and print sizes for use in the Library, to borrow or have delivered by our home library service.</p><p>Community programs for kids and young people, such as the PAWS (Port Adelaide Enfield Welcomes Children With Special Needs) have been created to engage and inspire our children in a safe and inclusive environment. Our Local History Collection also provides community access to dedicated resource to discover and uncover local and family history.</p><p>Libraries now also provide digital resources and technology to allow everyone access to information, job seeking and educational opportunities both in the Library or online.  Walk into a City of PAE Library and you’ll be able to access more technology than ever before- from free WiFi to PC access and digital training. Technology is changing the way we live and work. Schools are now focussing on science, technology, engineering and maths through their STEM program and more people are employed in tech related industries.</p><p>Libraries play an important role in this shift, giving customers an opportunity to interact with many different types of technology, arming them with lifelong skills.  They also help us to deliver our City Plan 2030 commitment of creating a City where people can participate in City life and feel a part of their local community.</p>",
              storyModal: false,
            },
          ],
          videos: [
            {
              videoTitle: "New community library opened",
              video:
                "https://www.youtube.com/watch?v=JxmAV9YEwII&list=PL_Jwyun8ksFpdV0kKl_setkrV2ZMLF-L5&index=7",
              videoModal: false,
            },
            {
              videoTitle: "A Day in the Life of - Librarians",
              video: "https://youtu.be/3s73hApFVFI",
              videoModal: false,
            },
          ],
          goals: [
            {
              title: "Community",
              image_url: "/images/CityPlan/cityplan-community.png",
            },
          ],
        },

        {
          title: "Protecting our environment",
          description:
            "From the air we breathe to the water we drink to where our kids play, we are committed to looking after the sustainability of our natural resources and streetscapes of our community.",
          image: "rates-environment.jpg",
          // budget: {
          //   "2018/2019": 0.0,
          //   "2019/2020": 0.0,
          //   "2020/2021": 0.0
          // },
          "2018/2019": {
            budget: 0.0488,
          },
          "2019/2020": {
            budget: 0.0544,
          },
          "2020/2021": {
            budget: 0.051584,
          },
          "2021/2022": {
            budget: 0.06,
          },          
          links: [
            {
              title: "Coastal Protection",
              url: "409192",
            },
            {
              title: "Streetscaping",
              url: "409307",
            },
            {
              title: "Street Cleaning",
              url: "",
            },
          ],
          stories: [
            {
              storyBudgetYear: "2019/20",
              storyTitle: "Plenty of plants",
              story:
                "<p>Green thumbs were busy in the Klemzig Ward on Sunday 24 June 2018, when an Arbor Day event was held at Beefacres Reserve, Windsor Gardens. Arbor Day was first celebrated in America in 1874 - and is now recognised globally as a day set aside for tree planting. More than 160 community members worked together on Arbor Day to increase the number of native plants along a 280m stretch of riverbank, planting native species including pigface, wattle, saltbush, daisy and grasses. Over 3,500 plants were lovingly planted in an area which had experienced tree loss due to higher water flow in the Torrens during 2016. There was also a tree trail to follow, designed to help families learn about the trees native to the area, and hands on activities for children. Another popular part of the Abor Day event was a workshop by ABC Gardening presenter Sophie Thompson, who demonstrated how to build a native bee ‘B’n’B’ so that residents can learn how to help improve the overall numbers of native bees in the area. Our City is unique in its combination of extremely valuable, and valued, ecological systems and natural areas alongside highly urbanised and major industrial precincts. Our commitment to preserving our unique environment was identified as a priority in our City Plan 2030 as we strive for sustainability and the effective protection of our precious resources.</p>",
              storyModal: false,
            },
            {
              storyBudgetYear: "2019/20",
              storyTitle:
                "Involving young people in caring for our environment",
              story:
                "<p>We are always looking for exciting new ways to get the community involved in looking after and protecting our natural environment. As part of our Environment Community Program, we teamed up with the Natural Resources Management Authority and an estuary ecologist to trial a number of education activities with 30 year 9 students from Portside Christian College.</p><p>The students learnt about the importance of the local coastal habitats and had a blast collecting and identifying all types of shellfish, sea snails and invertebrates from the coast and beach. Later in the day, the students took part in a weed mapping exercise along the beach and learnt about the vulnerable Red-Capped Plover shorebird species.</p><p>The learnings from these activities will go towards accreditation to their Conservation and Land Management Course. We have also partnered with Conservation Volunteers Australia and 90 Year 8 students from St Paul`s College Gilles Plains, to do some general maintenance on the natural environment and remove tree guards from the established plants to allow them to grow further. As part of our Environmental Community Program, this was a chance to teach eager students about the purpose of the wetlands while also providing them with an opportunity to contribute to their local community.</p><p>We are committed to protecting our natural environment, in line with our 2030 City Plan, and by working with young people we can equip future generations to help us care for our beautiful natural resources.</p>",
              storyModal: false,
            },
          ],
          goals: [
            {
              title: "Environment",
              image_url: "/images/CityPlan/cityplan-environment.png",
            },
          ],
        },

        {
          title: "Creating a safer community",
          description:
            "We work with all sectors of our community on assessing building safety, inspecting food premises, preventing fires and managing animals to reduce harm and risk and increase our overall safety.",
          image: "rates-public-order-safety.jpg",
          // budget: {
          //   "2018/2019": 0.0,
          //   "2019/2020": 0.0,
          //   "2020/2021": 0.0
          // },
          "2018/2019": {
            budget: 0.0441,
          },
          "2019/2020": {
            budget: 0.0483,
          },
          "2020/2021": {
            budget: 0.046195,
          },
          "2021/2022": {
            budget: 0.05,
          },          
          links: [
            {
              title: "Fire Prevention",
              url: "415243",
            },
            {
              title: "Food Business Inspections",
              url: "414837",
            },
            {
              title: "Building Assessment",
              url: "408877",
            },
            {
              title: "Animal Management",
              url: "408641",
            },
            {
              title: "Community Emergency Management Plan",
              url: "409533",
            },
          ],
          stories: [
            {
              storyBudgetYear: "2019/20",
              storyTitle: "Planning for our pets",
              story:
                "<p>Our Animal Management Plan was released in 2018 and aims to achieve key outcomes that articulate both Council’s and the community’s dog and cat priorities for the next five years.  Planning for pets (particularly dogs in public places) is a key consideration for local councils given dogs are the most popular pet in Australia. We also know that levels of dog ownership are higher in our beachside suburbs, with North Haven, Largs Bay and Largs North and Semaphore among the top suburbs for dog ownership within the City of PAE.  The feedback we received through community consultation while developing the plan indicates a need for pet owners to be able to maintain effective control of their dogs, especially when enjoying our shared open spaces such as the foreshore. It is important for dogs and their owners to be trained to deal with real life settings and to be able to cope with their pet’s excitement at the prospect of a beach walk, for example. We’re also now working with adjoining Councils to promote common messages about responsible dog ownership across the shared boundary along the foreshore, and we are undertaking work to support residents with advice about important changes to the Dog and Cat Management Act 1995 that came into operation on 1 July 2018.</p>",
              storyModal: false,
            },
            {
              storyBudgetYear: "2019/20",
              storyTitle: "Testing those tasty treats",
              story:
                "<p>There are more than 950 food businesses within the City of Port Adelaide Enfield including restaurants, takeaways, deli`s, greengrocers, markets, cafes, bakeries, sporting clubs, childcare centres and more.</p><p>Food safety is paramount for food businesses operating in our City so we have a team of Environmental Health Officers out and about in the community making sure that businesses meet food safety and health requirements under the Food Act and Food Safety Standards determined by SA Health, to provide safe and suitable food to our community.</p><p>Our team carry out approximately 500 inspections of local food businesses annually. While providing businesses with the right information and training, the team work extensively with owners to improve compliance with the food safety standards. During routine food safety inspections, Council’s Officers calculate a score based on how well the food business meets these food safety standards. This score is interpreted into a star rating and businesses that score 3, 4 or 5 stars receive a Certificate to display proudly and let customers know food safety standards have been met. If a score of less than 3 stars is calculated a certificate will not be awarded and our officers will work with the business to improve compliance.</p><p>If you are dining at one of our many food businesses, and you notice the star safety certificate, you can be sure Council has been working there to help ensure food safety. In line with our City Plan 2030, our Environmental Health Officers contribute to our goal of creating a healthy City.</p>",
              storyModal: false,
            },
          ],
          goals: [
            {
              title: "Community",
              image_url: "/images/CityPlan/cityplan-community.png",
            },
          ],
        },

        {
          title: "Maintaining public facilities",
          description:
            "To enhance our lifestyles and increase our overall sense of wellbeing in our community, we develop and maintain a number of community amenities, services and communication networks.",
          image: "rates-community-amenities.jpg",
          // budget: {
          //   "2018/2019": 0.0,
          //   "2019/2020": 0.0,
          //   "2020/2021": 0.0
          // },
          "2018/2019": {
            budget: 0.0192,
          },
          "2019/2020": {
            budget: 0.0208,
          },
          "2020/2021": {
            budget: 0.014368,
          },
          "2021/2022": {
            budget: 0.02,
          },          
          links: [
            {
              title: "Parking Services",
              url: "414921",
            },
            {
              title: "Toilets",
              url: "",
            },
            {
              title: "Plant Nursery",
              url: "",
            },
            {
              title: "Bus Stops",
              url: "",
            },
            {
              title: "Street Naming",
              url: "",
            },
            {
              title: "Telecommunications Networks",
              url: "",
            },
          ],
          stories: [
            {
              storyBudgetYear: "2019/20",
              storyTitle: "We’re Changing places",
              story:
                "<p>Our Parks Library has the first accredited Changing Places in South Australia. With an adult change table, a tracking hoist system, peninsula toilet and privacy curtain, this space helps individuals and their carers to participate in the social life of our community. The Changing Places also features a nature-inspired ceiling design in colours which are both calming and soothing. The facility is accessible using a MLAK key and a key is also available from the Customer Service Desk at the library. Without the features of a Changing Places toilet, the standard accessible toilet is not functional and therefore many people with a disability and their carers are left with the options of staying home, leaving the library prematurely or having to be changed on the floor of a public toilet.</p>",
              storyModal: false,
            },
          ],
          goals: [
            {
              title: "Placemaking",
              image_url: "/images/CityPlan/cityplan-placemaking.png",
            },
          ],
        },

        {
          title: "Creating jobs and increasing prosperity",
          description:
            "We work to attract, support and grow businesses and our community and we continue to pursue new initiatives, programs and community events that also attract visitors to the area.",
          image: "rates-economic-development.jpg",
          // budget: {
          //   "2018/2019": 0.0,
          //   "2019/2020": 0.0,
          //   "2020/2021": 0.0
          // },
          "2018/2019": {
            budget: 0.017,
          },
          "2019/2020": {
            budget: 0.0207,
          },
          "2020/2021": {
            budget: 0.017122,
          },
          "2021/2022": {
            budget: 0.02,
          },          
          links: [
            {
              title: "Tourism",
              url: "408980",
            },
            {
              title: "Events",
              url: "406627",
            },
            {
              title: "Business Support",
              url: "408733",
            },
          ],
          stories: [
            {
              storyBudgetYear: "2019/20",
              storyTitle: "Smart signage in the Port",
              story:
                "<p>Smart Wayfinding in Port Adelaide Centre will enable visitors to connect with local attractions and activities in Port Adelaide, and showcase the rich cultural and heritage experiences on offer via digitalised tourism information platform.  During 2019-2020 we have provided $100,000 matching funding to partner with the Commonwealth Government in developing a digital platform for a centralised real-time tourism information, installing smart interactive digital signage and free public Wi-Fi network in key tourist and activity areas to assist visitors’ navigation and improve tourist experience in the Port Centre. The project will stimulate tourism and business growth support population and economic growth, the creation of employment hubs and high density residential development, supporting technological innovation.</p>",
              storyModal: false,
            },
            {
              storyBudgetYear: "2019/20",
              storyTitle: "Events offer something for everyone",
              story:
                "<p>Each year we deliver a program of high profile community events, such as the three free outdoor movie screenings held at the picturesque Klemzig reserve in late 2018 and early 2019.  These events were attended by 500 people comprising mostly local and culturally diverse families from the immediate area. The screening of “The Greatest Showman” was targeted towards young people and featured food trucks, live music and an obstacle course.  Events support our City Plan outcomes aligned to personal wellbeing and community cohesion by creating fun and engaging environments and contexts for a wide cross-section of our community to relax, celebrate and share positive experiences. Annually our event program enables over 60,000 individuals, as well as numerous businesses, to personally benefit from and experience event outcomes.</p>",
              storyModal: false,
            },
            {
              storyBudgetYear: "2019/20",
              storyTitle: "Making business our business",
              story:
                "<p>Our City offers opportunity for business unmatched in the state. With over 8,100 businesses employing over 72,000 people, our region is a significant employer and will play a major role in the development of the South Australian economy into the future.</p><p>We work in line with our 2020 Economic Development Strategy, which identifies priorities that reflect the need of communities to adapt to economic and social change with a focus on building connections, infrastructure and partnership that will help drive growth.</p><p>We work with government, community and business partners to maximise the opportunities available in our Council area for commerce. We continue to build strategic partnerships with other councils plus industry and business networks across the state. This process is an important part of supporting economic capacity and confidence. Our approach reflects our focus on supporting collaborative and connected economic regions, promoting tourism and supporting small businesses. We have worked with neighbouring Council’s to develop a Western Adelaide Tourism Strategy and have continued to play an active role in the Northern Economic Plan.</p><p>During the last financial year 28 Start-up and 32 Expansion business grants have been received by local businesses. This totals in excess of $2.7 million dollars and the creation of approximately 200 new jobs in the region.  The work carried out as part of our Economic Development Strategy helps us achieve our City Plan 2030 goal of creating a City of opportunity which is prosperous, connected and growing.</p>",
              storyModal: false,
            },
          ],
          videos: [
            {
              videoTitle:
                "Santos Tour Down Under 2019 Peloton at Port Adelaide Party",
              video:
                "https://www.youtube.com/watch?v=8B0EGdFSsMg&list=PL_Jwyun8ksFr4RJKiXbI7oFRTCoD09u7k&index=14",
              videoModal: false,
            },
          ],
          goals: [
            {
              title: "Economy",
              image_url: "/images/CityPlan/cityplan-economy.png",
            },
          ],
        },

        {
          title: "Lighting our city streets",
          description:
            "We are committed to continue to increase community safety by creating a lighter, safer region at night, with improved and sustainable street lighting.",
          image: "rates-lighting.jpg",
          // budget: {
          //   "2018/2019": 0.0,
          //   "2019/2020": 0.0,
          //   "2020/2021": 0.0
          // },
          "2018/2019": {
            budget: 0.0148,
          },
          "2019/2020": {
            budget: 0.0159,
          },
          "2020/2021": {
            budget: 0.015724,
          },
          "2021/2022": {
            budget: 0.01,
          },          
          links: [
            {
              title: "Street Lights",
              url: "",
            },
          ],
          stories: [
            {
              storyBudgetYear: "2019/20",
              storyTitle: "Shining a light around a City",
              story:
                "<p>With a City that covers around 97 square kilometres, it’s no wonder that two cents in every rates dollar goes towards keeping all those streets, parks and open spaces lit at night.  Effective street lighting has been shown to reduce risks for drivers, riders and pedestrians and also helps create a feeling of safety for residents, which is something we strive for in line with our City Plan 2030.</p><p>Council covers the annual cost of street lighting on all local roads and 50% of lighting on arterial roads but that’s not all.  We regularly install new or improved lighting on reserves as they are upgraded, and conduct night-time audits of all of our reserve lighting every two months to ensure they are adequately lit. Last financial year we also handled more than 100 customer requests for street lighting maintenance and for additional lighting.</p><p>Council is also participating in a statewide program called PLEC, in which stobie poles are removed and power cables placed underground. This initiative has been completed along Prospect Road in Kilburn and on Semaphore Road, Semaphore and will also be occurring soon along Hampstead Road, Manningham and Jetty Road, Largs Bay, where light columns and street scaping upgrades will also be installed.</p><p>And we are always looking for ways we can improve efficiency in lighting. A bulk changeover of all our lighting assets to LED technology is scheduled, which will reduce power costs and greenhouse gas emissions and help us achieve our City Plan 2030 goals around sustainability.</p>",
              storyModal: false,
            },
          ],
          goals: [
            {
              title: "Placemaking",
              image_url: "/images/CityPlan/cityplan-placemaking.jpg",
            },
          ],
        },
      ],
    };
  },
  watch: {
    calctype: function (v) {
      if (v == "Dollar") {
        this.totalAmount = this.dollar;
      } else if (v == "Rates") {
        this.totalAmount = this.rates;
      } else if (v == "Budget") {
        this.totalAmount = this.budget;
      }
    },
    rates: function () {
      this.rates = this.rates > 999999999 ? 999999999 : this.rates;
      this.totalAmount = this.rates == 1 ? this.dollar : this.rates;
    },
  },

  methods: {
    calculation(ratio) {
      let v = this.totalAmount * ratio;
      //console.log('val: ' + this.value + ' ratio:' + ratio + ' v: ' + v)
      return this.toCurrency(v);
    },

    abbreviate(v) {
      let suffix = "";

      //return v
      if (v > 999999) {
        v = v / 1000000;
        suffix = "M";
      } else if (v > 9999) {
        v = v / 1000;
        suffix = "K";
      }

      v = (v / 1).toFixed(2);

      //v = v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

      return "$" + v + suffix;
    },

    toCurrency(v) {
      //return new Intl.NumberFormat('en-US').format(price);
      let val = (v / 1).toFixed(2);
      return this.abbreviate(v);
    },

    toCurrencyDigits(v) {
      let val = (v / 1).toFixed(2);
      return val;
      // let val = this.value
      // return val.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    togglePeriods(year) {
      this.periods.forEach(function (period) {
        if (period.year == year) {
          if (period.selected == false) period.selected = true;
        } else {
          period.selected = false;
        }
      });
      this.updateValues();
    },
    updateValues() {
      const self = this;
      this.periods.forEach(function (period) {
        if (period.selected == true) {
          self.budget = period.budget;
          self.budgetType = period.type;
          self.dollar = period.dollar;
          self.value = period.budget;
          self.selectedYear = period.year;
          self.selectedYearMaps = period.yearMaps;
          self.totalAmount = period.dollar;
          self.showRoundingNote = period.showRoundingNote;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.themes {
  background: #eee;
  padding: 0.5rem 1rem;
  border-radius: 8px;

  h3 {
    font-weight: 900;
  }

  small {
    font-size: 0.8rem;
  }
}
</style>


// WEBPACK FOOTER //
// Modules/CityPlan/Resources/assets/js/components/RatesDollarList.vue